import * as XLSX from 'xlsx';

/** Bytes from a fetched document. FileReader covers viewers that have no Blob.arrayBuffer. */
export function readBlobBuffer(blob) {
  if (blob && typeof blob.arrayBuffer === 'function') return blob.arrayBuffer();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('The document could not be read.'));
    reader.readAsArrayBuffer(blob);
  });
}

/** Text from a fetched document. FileReader covers viewers that have no Blob.text. */
export function readBlobText(blob) {
  if (blob && typeof blob.text === 'function') return blob.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('The document could not be read.'));
    reader.readAsText(blob);
  });
}

/** First worksheet as text rows. Used only to draw a stored spreadsheet. */
export function readSpreadsheetRows(buffer) {
  const bytes = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : buffer;
  const book = XLSX.read(bytes, { type: 'array' });
  const name = book.SheetNames[0];
  if (!name) return [];
  const grid = XLSX.utils.sheet_to_json(book.Sheets[name], {
    header: 1,
    raw: false,
    defval: '',
  });
  return grid
    .map((row) => (Array.isArray(row) ? row.map((cell) => String(cell ?? '')) : []))
    .filter((row) => row.some((cell) => cell.trim() !== ''));
}
